function y(e,l,o){let n;return function(...t){let a=this,i=t[0]?.composedPath?.();i?.length&&(t[0].orignPath=i);let u=()=>{o||e.apply(a,t),n=null};n?clearTimeout(n):o&&e.apply(a,t),n=setTimeout(u,l||250)}}export{y as a};
